@switch (notification.userNotificationType) {
  @case ('Generic') {
    <rma-notification-item-generic [containerClass]="containerClass" [notification]="notification" (navigate)="navigate.emit($event)" />
  }
  @default {
    <rma-notification-item-system
      [containerClass]="containerClass"
      [showStatusIcon]="showStatusIcon"
      [notification]="notification"
      (navigate)="navigate.emit($event)"
    />
  }
}
